export enum GameServiceEvent {
    ERROR = 'on_error_received',
    DOUBLE_CHANCE_CHANGED = 'onDoubleChanceChanged',
    SETTINGS_CHANGED = 'onSettingsChanged'
}